import BaseSkeleton from './BaseSkeleton';

const PlayerSkeleton = props => {
  return (
    <BaseSkeleton
      shape="square"
      borderRadius="10px"
      height={500}
      animation={props.animation}
    />
  );
};

export default PlayerSkeleton;
